import type { ComponentType } from 'react';

import { ApprovalCardNode } from './nodes/approval-card';
import { ChartNode } from './nodes/chart-node';
import { CommentDraftCardNode } from './nodes/comment-draft-card';
import { ContentCardNode } from './nodes/content-card';
import { DraftCardNode } from './nodes/draft-card';
import { FollowUpsNode } from './nodes/follow-ups-node';
import { GifPickerCardNode } from './nodes/gif-picker-card';
import { MarkdownNode } from './nodes/markdown-node';
import { MatrixNode } from './nodes/matrix-node';
import { MeetingPeopleCardNode } from './nodes/meeting-people-card';
import type { BizyNodeProps } from './nodes/node-props';
import { PersonPickerNode } from './nodes/person-picker-card';
import { RecognitionAppreciationCardNode } from './nodes/recognition-appreciation-card';
import { RecognitionDraftCardNode } from './nodes/recognition-draft-card';
import { RecognitionViewCardNode } from './nodes/recognition-view-card';
import { ScorecardNode } from './nodes/scorecard-node';
import { SourceDetailsNode } from './nodes/source-details-node';
import { TableNode } from './nodes/table-node';
import { UserAdminBatchConfirmCardNode } from './nodes/user-admin-batch-confirm-card';

export type BizyNodeComponent = ComponentType<BizyNodeProps>;

/**
 * Registry: `node.type` → renderer component. The DocumentRenderer looks each
 * node up here and falls back to `UnsupportedNode` for unknown types.
 *
 * Adding a new node type in the future: add the renderer, register it here,
 * and bump the bizy-kit version — both apps pick it up on the next install.
 */
export const defaultRegistry = new Map<string, BizyNodeComponent>([
	['markdown', MarkdownNode],
	['follow_ups', FollowUpsNode],
	['scorecard', ScorecardNode],
	['chart', ChartNode],
	['matrix', MatrixNode],
	['table', TableNode],
	['source_details', SourceDetailsNode],
	['approval_card', ApprovalCardNode],
	['content_card', ContentCardNode],
	['draft_card', DraftCardNode],
	['meeting_people_card', MeetingPeopleCardNode],
	['person_picker', PersonPickerNode],
	['recognition_draft_card', RecognitionDraftCardNode],
	['comment_draft_card', CommentDraftCardNode],
	['recognition_view_card', RecognitionViewCardNode],
	['recognition_appreciation_card', RecognitionAppreciationCardNode],
	['gif_picker_card', GifPickerCardNode],
	['user_admin_batch_confirm_card', UserAdminBatchConfirmCardNode],
]);
